export const colors = {
	white: '#ffffffff',
	black: '#14151aff',
	gray: {
		'25': '#f6f6f9ff',
		'50': '#edeef3ff',
		'100': '#dbdfe6ff',
		'200': '#c6cbd2ff',
		'300': '#a6acb5ff',
		'400': '#898f9aff',
		'500': '#656c7bff',
		'600': '#515661ff',
		'700': '#3c3f49ff',
		'800': '#2d3039ff',
		'900': '#1d1f25ff',
	},
	grayAlpha: {
		'50': '#6b74850a',
		'100': '#6b748514',
		'150': '#6b74851f',
		'200': '#6b748529',
		'250': '#6b748533',
		'300': '#6b74853d',
		'400': '#6b748552',
		'500': '#6b748566',
	},
	blue: {
		'25': '#eef7fcff',
		'50': '#d8ecf8ff',
		'100': '#b4d5f3ff',
		'200': '#8fbcf0ff',
		'300': '#5ba1f1ff',
		'400': '#2981e5ff',
		'500': '#1670dfff',
		'600': '#1358b9ff',
		'700': '#14458aff',
		'800': '#103560ff',
		'900': '#08253fff',
	},
	blueAlpha: {
		'50': '#1670df0a',
		'100': '#1670df14',
		'150': '#1670df1f',
		'200': '#1670df29',
		'250': '#1670df33',
		'300': '#1670df3d',
		'400': '#1670df52',
		'500': '#1670df66',
	},
	green: {
		'25': '#ecf8f1ff',
		'50': '#d9f2e3ff',
		'100': '#afdfc1ff',
		'200': '#7ccb9bff',
		'300': '#4bb475ff',
		'400': '#1e9f54ff',
		'500': '#118342ff',
		'600': '#066a35ff',
		'700': '#055229ff',
		'800': '#073b21ff',
		'900': '#062819ff',
	},
	greenAlpha: {
		'50': '#1183420a',
		'100': '#11834214',
		'150': '#1183421f',
		'200': '#11834229',
		'250': '#11834233',
		'300': '#1183423d',
		'400': '#11834252',
		'500': '#11834266',
	},
	red: {
		'25': '#fbf3f3ff',
		'50': '#fbeaeaff',
		'100': '#f2c5c5ff',
		'200': '#efaaa9ff',
		'300': '#ee7c7cff',
		'400': '#f04747ff',
		'500': '#d82c2fff',
		'600': '#ad2527ff',
		'700': '#832421ff',
		'800': '#5e1b17ff',
		'900': '#421410ff',
	},
	redAlpha: {
		'50': '#d82c2f0a',
		'100': '#d82c2f14',
		'150': '#d82c2f1f',
		'200': '#d82c2f29',
		'250': '#d82c2f33',
		'300': '#d82c2f3d',
		'400': '#d82c2f52',
		'500': '#d82c2f66',
	},
	purple: {
		'25': '#f8f6feff',
		'50': '#efedfcff',
		'100': '#dbd7f9ff',
		'200': '#bab2f5ff',
		'300': '#9c8ef1ff',
		'400': '#8c75ebff',
		'500': '#7b5ce0ff',
		'600': '#6940ceff',
		'700': '#5036a6ff',
		'800': '#3a2579ff',
		'900': '#2b1551ff',
	},
	purpleAlpha: {
		'50': '#7b5ce00a',
		'100': '#7b5ce014',
		'150': '#7b5ce01f',
		'200': '#7b5ce01f',
		'250': '#7b5ce029',
		'300': '#7b5ce033',
		'400': '#7b5ce052',
		'500': '#7b5ce066',
	},
	yellow: {
		'25': '#fdfaddff',
		'50': '#faf0c7ff',
		'100': '#fbde8eff',
		'200': '#fcc84fff',
		'300': '#e6ae14ff',
		'400': '#c28c05ff',
		'500': '#b37e00ff',
		'600': '#916402ff',
		'700': '#5e4003ff',
		'800': '#4d3505ff',
		'900': '#382705ff',
	},
	yellowAlpha: {
		'100': '#986b0114',
	},
	orange: {
		'25': '#fff3e5ff',
		'50': '#ffe3baff',
		'100': '#ffc988ff',
		'200': '#ffaa51ff',
		'300': '#ff8b1bff',
		'400': '#df6507ff',
		'500': '#b44a0bff',
		'600': '#8a3605ff',
		'700': '#762c00ff',
		'800': '#642700ff',
		'900': '#471700ff',
	},
	orangeAlpha: {
		'50': '#ff65070a',
		'100': '#ff650714',
		'150': '#ff65071f',
		'200': '#ff650729',
		'250': '#ff650733',
		'300': '#ff65073d',
		'400': '#ff650752',
		'500': '#ff650766',
	},
	pink: {
		'25': '#fff4f4ff',
		'50': '#ffe2ebff',
		'100': '#ffccdeff',
		'200': '#feafcbff',
		'300': '#fa82afff',
		'400': '#e5548fff',
		'500': '#c03670ff',
		'600': '#9e2b5cff',
		'700': '#7b1f49ff',
		'800': '#611139ff',
		'900': '#4a0228ff',
	},
	pinkAlpha: {
		'50': '#e5548f0a',
		'100': '#e5548f14',
		'150': '#e5548f1f',
		'200': '#e5548f29',
		'250': '#e5548f33',
		'300': '#e5548f3d',
		'400': '#e5548f52',
		'500': '#e5548f66',
	},
	teal: {
		'25': '#e6fcfaff',
		'50': '#cef9f4ff',
		'100': '#a8f5eeff',
		'200': '#72ddd3ff',
		'300': '#44c0b5ff',
		'400': '#279f95ff',
		'500': '#1d7f77ff',
		'600': '#0b5f59ff',
		'700': '#004944ff',
		'800': '#003532ff',
		'900': '#002422ff',
	},
	tealAlpha: {
		'50': '#279f950a',
		'100': '#279f9514',
		'150': '#279f951f',
		'200': '#279f9529',
		'250': '#279f9533',
		'300': '#279f953d',
		'400': '#279f9552',
		'500': '#279f9566',
	},
	coral: {
		'25': '#fff0ebff',
		'50': '#ffe6dfff',
		'100': '#ffd9ccff',
		'200': '#ffb4a1ff',
		'300': '#fd8c73ff',
		'400': '#f0664aff',
		'500': '#c4432bff',
		'600': '#9e2f1cff',
		'700': '#861f0fff',
		'800': '#691105ff',
		'900': '#510901ff',
	},
	coralAlpha: {
		'50': '#f0664a0a',
		'100': '#f0664a14',
		'150': '#f0664a1f',
		'200': '#f0664a29',
		'250': '#f0664a33',
		'300': '#f0664a3d',
		'400': '#f0664a52',
		'500': '#f0664a66',
	},
	blackAlpha: {
		'50': '#14151a0a',
		'100': '#14151a14',
		'150': '#14151a1f',
		'200': '#14151a29',
		'300': '#14151a3d',
		'400': '#14151a52',
		'500': '#14151a66',
		'600': '#14151a7a',
		'700': '#14151a8f',
		'800': '#14151aa3',
		'900': '#14151ab8',
		'1000': '#14151acc',
		'1100': '#14151ae0',
		'1200': '#14151af5',
	},
	whiteAlpha: {
		'50': '#ffffff0a',
		'100': '#ffffff14',
		'150': '#ffffff1f',
		'200': '#ffffff29',
		'300': '#ffffff3d',
		'400': '#ffffff52',
		'500': '#ffffff66',
		'600': '#ffffff7a',
		'700': '#ffffff8f',
		'800': '#ffffffa3',
		'900': '#ffffffb8',
		'1000': '#ffffffcc',
		'1100': '#ffffffe0',
		'1200': '#fffffff5',
	},
};
